import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import HeaderLogin from "../components/HeaderLogin";
import banner from '../assets/banner.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

const LogoutSuccess = () => {
  return (
    <div>
      <HeaderLogin />
      <div className="container text-center d-flex align-items-center" style={{ marginTop: '100px', height: '100%' }}>
        <div>
          <img src={banner}></img>
        </div>
        <div>
          <h1><FontAwesomeIcon icon={faCheckCircle} style={{ color: 'green' }}></FontAwesomeIcon> You have successfully logged out</h1>
          <p>
            <a href="/" className="btn-goto-home">
              Go to Home Page    <FontAwesomeIcon icon={faArrowRight}></FontAwesomeIcon>
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LogoutSuccess;
